const accessPointPaths = {
  ACCESS_POINT: "",
  ACCESS_POINT_SEARCH: "search",
  ACCESS_POINT_BATCH: "batch",
  // ACCESS_POINT_SEARCH_REPORT: "graph/unique-attendee",
  ACCESS_POINT_EXPORT_REPORT: "search",
};

export default accessPointPaths;
